import React, { Component } from 'react'

import { withTranslation } from 'react-i18next'
import axios from 'axios'

import Bygg from './Bygg.jsx'
import ByggIcon from '../../../images/Bygg.png'
import CollapseIcon from '../../../images/expand copy 3.png'
import ExpandIcon from '../../../images/collapse copy 3.png'

class ByggList extends Component {
    state = {
        bygg: [],
        isLoading: false,
        isOpened: false,
        continuationToken: null        
    }

    getBygg = () => {
        this.setState({isLoading: true})
        axios.get(`${this.props.settings.baseUrl}api/matrikkelenhet/${this.props.matrikkelenhetId}/bygg`, {
            params: {
                token: this.props.token,
                size: 50,
                continuationToken: this.state.continuationToken                
            }
        })
        .then(({data}) => {
            this.setState({
                bygg: [...this.state.bygg, ...data.bygg].sort(this.byggComparer),
                isLoading: false,
                continuationToken: data.nextContinuationToken
            })
        })
      }

    byggComparer = (a, b) => {
        if (a.bygningstypeKode == null || b.bygningstypeKode == null) return 1
        if (a.bygningstypeKode > b.bygningstypeKode) return 1
        if (a.bygningstypeKode < b.bygningstypeKode) return -1
        return 0
    }

    toggleBygg = () => {
        if (this.props.antall == 0) return

        if (this.state.bygg.length == 0) {
            this.getBygg()
        }

        this.setState({isOpened: !this.state.isOpened})
    }

    kopierBygg = event => {
        event.stopPropagation()

        if (this.state.bygg.length == 0) return;
        const replacer = (key, value) => value === null ? '' : value
        const header = Object.keys(this.state.bygg[0])
        const csv = [
          header.join(','),
          ...this.state.bygg.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','))
        ].join('\r\n')
        
        navigator.clipboard.writeText(csv)
    }

    render() {
        const { t } = this.props        
        var antallBygg = this.state.continuationToken ? `${this.state.bygg.length}/${this.props.antall}` : this.props.antall
        return (
            <li>
                <div className="section-header" onClick={this.toggleBygg}>
                    { !this.state.isLoading &&
                        <div className="icon-image"><img src={ByggIcon} /></div>
                    }
                    {
                        this.state.isLoading &&
                        <span className="icon"><i className="fa fa-fw fa-spinner fa-spin"></i></span>
                    }
                    <span className="title">{t('bygg')} ({antallBygg})</span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>

                    { this.state.isOpened &&
                    <div className="icon-image right tooltip" onClick={this.kopierBygg}>
                        <i className="fa fa-clipboard"></i>
                        <div className="tooltip-content">{t('vis.kopierbygg')}</div>
                    </div> }
                </div>
              
                <div className={this.state.isOpened && this.state.bygg.length > 0 ? "" : "collapsed"}>
                    <ul>
                        {this.state.bygg.map((b, index) => { return (<Bygg key={b.byggId} bygg={b} antall={this.props.antall} isLast={index==this.state.bygg.length-1} onEvent={this.props.onEvent} onMatrikkelObjectSelected={this.props.onMatrikkelObjectSelected} />)}) }
                        { this.state.continuationToken &&
                        <li key="HentFlere">
                            <div className="section-header subsection button" onClick={this.getBygg}>
                                <span>{t('hent.bygg')}</span>
                            </div>
                        </li>
                        }
                    </ul>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(ByggList)